// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2mvwG","actionsCol":"EnrolledClinics_actionsCol__3gLbz"};